(function () {
  // Unlike blog-posts.js (single swiper per page), the homepage renders two
  // featured-collections instances at once (Nerada grid + Leaf Lab
  // "Discover our lab" slider), so each slider keeps its own Swiper instance
  // on the element rather than in a module-level variable.

  // Brand-scoped sections (data-brand-scope, docs/architecture-dual-brand.md)
  // are display:none under the other brand's skin. Initializing Swiper on a
  // 0-width element bakes in broken measurements that the in-page brand
  // preview toggle never corrects, so defer init until the slider first has
  // layout -- the ResizeObserver fires when the brand swap reveals it.
  const initWhenMeasurable = (slider) => {
    if (slider.swiperInstance) return;

    if (slider.offsetWidth > 0) {
      initSlider(slider);
      return;
    }

    const visibilityObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width > 0 && !slider.swiperInstance) {
          visibilityObserver.disconnect();
          initSlider(slider);
        }
      });
    });

    visibilityObserver.observe(slider);
  };

  const initSlider = (slider) => {
    if (slider.swiperInstance) return;

    slider.classList.add("swiper");

    const wrapper = slider.querySelector(".featured-collections__grid");

    if (!wrapper) return;

    wrapper.classList.add("swiper-wrapper");

    const slides = slider.querySelectorAll(".featured-collections__item");

    if (!slides || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    slider.swiperInstance = new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 1000,
    });
  };

  const destroySlider = (slider) => {
    if (!slider.swiperInstance) return;

    const slides = slider.querySelectorAll(".featured-collections__item");
    const wrapper = slider.querySelector(".featured-collections__grid");

    slider.classList.remove("swiper");

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });

    if (wrapper) {
      wrapper.removeAttribute("style");
      wrapper.classList.remove("swiper-wrapper");
    }

    slider.swiperInstance.destroy(true, true);
    slider.swiperInstance = null;
  };

  const setup = (root) => {
    root
      .querySelectorAll(".swiper--featured-collections")
      .forEach((slider) => {
        // data-desktop-slider ("Slider at all widths" setting) keeps the
        // swiper active at every width; otherwise it only runs below the
        // theme's 750px breakpoint, mirroring blog-posts.js.
        if (slider.hasAttribute("data-desktop-slider")) {
          initWhenMeasurable(slider);
          return;
        }

        const section = slider.closest(".shopify-section") || slider.parentElement;

        const sectionResizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.contentRect.width < 750) {
              // The observer watches the section wrapper (which always has
              // width); the slider itself may still be brand-hidden, so route
              // through the measurability guard rather than initing directly.
              initWhenMeasurable(slider);
            } else {
              destroySlider(slider);
            }
          });
        });

        sectionResizeObserver.observe(section);
      });
  };

  setup(document);

  document.addEventListener("shopify:section:load", function (e) {
    setup(e.target);
  });
})();
